import { render, staticRenderFns } from "./SearchHelpcenter.vue?vue&type=template&id=02780063"
import script from "./SearchHelpcenter.vue?vue&type=script&lang=js"
export * from "./SearchHelpcenter.vue?vue&type=script&lang=js"
import style0 from "./SearchHelpcenter.vue?vue&type=style&index=0&id=02780063&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports